import LoadingPage from './../index.vue'
import { createApp, h } from 'vue'
const wrapperClassName = 'wyk-loading-page-wrapper-flag-box'
const LOADINGMINSECOND = 500

const _createLoading = (className) => {
  const loadingIns = createApp({
    render() { return h(LoadingPage) }
  })
  const container = document.createElement('div')
  container.classList.add(wrapperClassName)
  className && container.classList.add(className)
  loadingIns.mount(container)
  document.body.append(container)
  return [ loadingIns, Date.now() ]
}

const _removeLoading = (loadingIns, lastCallCreateTime) => {
  if (!loadingIns) { return }
  let nowTime = Date.now()
  let splitTime = nowTime - lastCallCreateTime
  if (splitTime < LOADINGMINSECOND) {
    return setTimeout(() => {
      _removeLoading(loadingIns, lastCallCreateTime)
    }, LOADINGMINSECOND - splitTime)
  }
  loadingIns.unmount()
  loadingIns = null
}

export function createLoading(className) {
  const [ loadingIns, lastCallCreateTime ] = _createLoading(className)
  return () => _removeLoading(loadingIns, lastCallCreateTime)
}

